export default __webpack_public_path__ + "static/social-26adb37cbb345a6922682a4e0cb4b6a2.jpg";